import React from "react";
import TopBanner from "../components/TopBanner";
import styled from "styled-components";
import Form from "../components/Form";

const TravelInsurance = () => {
  return (
    <>
      <TopBanner content={"Travel Insurance"} />
      <ContentWrapper>
        <div className="text-content">
          <h2>Travel Smart, Stay Covered</h2>
          <p>
            Travel insurance protects you from unexpected problems while you’re
            travelling whether it’s a medical emergency, trip cancellation, lost
            baggage, or flight delays. Whether you’re traveling within India or
            abroad, it ensures peace of mind every step of the way.
          </p>

          <h3>Types of Travel Insurance:</h3>
          <ul>
            <li>Domestic Travel Insurance – For travel within India</li>
            <li>International Travel Insurance – For trips abroad</li>
            <li>Student Travel Insurance – For those studying overseas</li>
            <li>Senior Citizen Travel Plans – Tailored for older travelers</li>
            <li>Multi-Trip Travel Plans – For frequent flyers</li>
          </ul>
          <h3>Why Travel Insurance?</h3>
          <ul>
            <li>Covers medical emergencies abroad</li>
            <li>Compensation for lost luggage and delayed flights</li>
            <li>Trip cancellation & interruption protection</li>
            <li>Required for visas in many countries (like Schengen)</li>
            <li>24/7 support during your journey</li>
          </ul>
        </div>
        <Form />
      </ContentWrapper>
    </>
  );
};

export default TravelInsurance;

export const ContentWrapper = styled.div`
  display: flex;
  padding: 100px;
  gap: 20px;

  .text-content {
    width: 50%;
    p,
    ul,
    li {
      font-size: 1.1rem;
      line-height: 1.6;
      color: #333;
      text-align: left;
    }
  }

  h3 {
    color: black;
  }

  @media (max-width: 900px) {
    flex-direction: column;
    padding: 30px;

    .text-content {
      width: 100%;
    }
  }
`;
